import { render, staticRenderFns } from "./ReplyBoxV2.vue?vue&type=template&id=2f0fddbe&scoped=true&"
import script from "./ReplyBoxV2.vue?vue&type=script&lang=js&"
export * from "./ReplyBoxV2.vue?vue&type=script&lang=js&"
import style0 from "./ReplyBoxV2.vue?vue&type=style&index=0&id=2f0fddbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0fddbe",
  null
  
)

export default component.exports